import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Parallax } from "react-parallax";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../layout/Navbar";
import Preloader from "../layout/preloader";
import Footer from "../section-pages/footer";
import ScrollToTopBtn from "../layout/ScrollToTop";
import { createGlobalStyle } from "styled-components";
import { BACKEND_ENDPOINT } from "../const/appConst";
const image1 = "./img/background/space.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
`;

export default function Home() {
  const navigate = useNavigate();

  const handleLogin = (provider) => {
    window.location.href = `${BACKEND_ENDPOINT}/login/${provider}`;
  };

  const handleLoginRedirect = async () => {
    console.log("login redirect");
    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get("userId");
    const profilePicture = urlParams.get("profilePicture");
    const accessToken = urlParams.get("accessToken");
    const refreshToken = urlParams.get("refreshToken");

    console.log(urlParams, userId, profilePicture, accessToken, refreshToken);

    if (userId && profilePicture && accessToken && refreshToken) {
      localStorage.setItem("userId", userId);
      localStorage.setItem("profilePicture", profilePicture);
      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("refreshToken", refreshToken);
      navigate("/dashboard"); // Redirect to dashboard after successful login
    }
  };

  useEffect(() => {
    handleLoginRedirect();

    if (typeof window !== "undefined") {
      const loader = document.getElementById("mainpreloader");
      if (loader)
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = "none";
        }, 600);
    }
  }, [navigate]);

  return (
    <>
      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Novelfy - login</title>
      </Helmet>

      <GlobalStyles />

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>

      {/* MENU */}
      <div className="home dark-scheme">
        <header id="header-wrap">
          <Navbar />
        </header>

        {/* section */}
        <Parallax className="" bgImage={image1} strength={5}>
          <div className="de-gradient-edge-top"></div>
          <div className="de-gradient-edge-bottom"></div>
          <section className="no-bg">
            <div className="container z-9">
              <div className="row align-items-center">
                <div className="col-lg-8 offset-lg-2">
                  <div
                    className="p-5 rounded-10 shadow-soft bg-dark-1"
                    id="login"
                  >
                    <form
                      name="contactForm"
                      id="contact_form"
                      className="form-border"
                    >
                      <h4>Don&apos;t have an account? Register now.</h4>
                      <p>
                        Welcome to Novelfy. We&apos;re excited to have you on
                        board. By creating an account with us, you&apos;ll gain
                        access to a range of benefits and convenient features
                        that will enhance your car rental experience.
                      </p>

                      <div className="col-lg-6 offset-lg-3">
                        <div className="title-line">
                          Or&nbsp;sign&nbsp;up&nbsp;with
                        </div>
                        <div className="row g-2">
                          <div className="col-lg-6">
                            <Link
                              className="btn-sc btn-fullwidth mb10"
                              to="#"
                              onClick={() => handleLogin("google")}
                            >
                              <img src="./img/svg/google_icon.svg" alt="" />
                              Google
                            </Link>
                          </div>
                          {/* <div className="col-lg-6">
                            <Link
                              className="btn-sc btn-fullwidth mb10"
                              to="#"
                              onClick={() => handleLogin("facebook")}
                            >
                              <img src="./img/svg/facebook_icon.svg" alt="" />
                              Facebook
                            </Link>
                          </div> */}
                          <div className="col-lg-6">
                            <Link
                              className="btn-sc btn-fullwidth mb10"
                              to="#"
                              onClick={() => handleLogin("twitter")}
                            >
                              <img src="./img/svg/twitter_icon.svg" alt="" />X
                            </Link>
                          </div>
                          <div className="col-lg-6">
                            <Link
                              className="btn-sc btn-fullwidth mb10"
                              to="#"
                              onClick={() => handleLogin("discord")}
                            >
                              <img src="./img/svg/discord_icon.svg" alt="" />
                              Discord
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </Parallax>

        {/* footer */}
        <Footer />
      </div>
      <ScrollToTopBtn />
    </>
  );
}
